export default __webpack_public_path__ + "static/media/profile_sm.30f65391.gif";